/** Factory tipada para localStorage — SSR-safe */

export function createStorage<T>(key: string, defaultValue: T) {
  const fullKey = `vml:${key}`;

  function get(): T {
    if (typeof window === 'undefined') return defaultValue;
    try {
      const raw = localStorage.getItem(fullKey);
      return raw ? (JSON.parse(raw) as T) : defaultValue;
    } catch {
      return defaultValue;
    }
  }

  function set(value: T): void {
    if (typeof window === 'undefined') return;
    try {
      localStorage.setItem(fullKey, JSON.stringify(value));
    } catch {
      // Silencioso — quota excedida ou privado
    }
  }

  function remove(): void {
    if (typeof window === 'undefined') return;
    localStorage.removeItem(fullKey);
  }

  return { get, set, remove, key: fullKey };
}
